// extracted by mini-css-extract-plugin
export var closeButton = "_m7-1";
export var closeX = "_m7-3";
export var container = "_m7-0";
export var image = "_m7-2";